import "./index.css";
import { useContext, useEffect, useState } from "react";
import { PtmMode } from "utilFunctions/Constants/Constants";
import SendCommentBox from "Pages/StudentPortfolio/StudentCommentSection/SendCommentBox";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { Button } from "reactstrap";
import CloseIcon from "Assets/Icons/CloseIcon";
import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import { usePutPostAPI } from "utilFunctions/CustomHooks/usePutPostAPI";
import { BASE_URL, POST_COMMENT } from "utilFunctions/Constants/urlConstants";
import { pushToDataLayerForGTM } from "utilFunctions/helperFunctions/analytics";
// import CloseRoundIcon from "Assets/Icons/CloseRoundIcon";
import { StudentContext } from "Context/StudentContext";
import { Select, DatePicker } from "antd";
import moment from "moment";
const StyledLOPTitleDiv = styled<any>("div")`
  color: var(--Grey-80, #333);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px; /* 175% */
  padding: 8px;
  padding-left: 0px;
  cursor: pointer;
  width: ${(props: any) =>
    ["xxl", "xl", "lg"].includes(props.screen)
      ? props.viewAllComments
        ? "20%"
        : "100%"
      : "100%"};
`;
const StyledLOPListingDiv = styled<any>("div")`
  white-space: nowrap;
  border-radius: 4px;
  background: ${(props: any) => (props.isSelected ? "#e5f6ff" : "#fff")};
  color: ${(props: any) => (props.isSelected ? "#00b0f5" : "#AFAFAF")};
  border: ${(props: any) =>
    props.isSelected ? "0.5px solid #00b0f5" : "0.5px solid #AFAFAF"};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 171.429% */
  padding: 8px;
  display: flex;
  align-items: center;
  margin-right: 16px;
  cursor: pointer;
`;
const CommentStyledDiv = styled<any>("div")`
  height: ${(props: any) => (props.height < 650 ? "300px" : "auto")};
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 20px;
  padding-bottom: 10px;
`;
interface AddCommentArrayInterface {
  name: string;
  value: string;
  data: any[];
  selectedValues: string | null;
  nextStep?: string;
}
const StudentAddComment = ({
  lopActionList,
  lopReasonList,
  viewAllComments,
  refreshComment,
  setRefreshComment,
  subjects,
  filterState,
  setFilterState,
  isAddNewComment,
  setIsAddNewComment,
  isCommentEdit,
  setIsCommentEdit,
  isPaneOpenComment,
  scrollToHeader,
}: any) => {
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const { selectedStudent } = useContext<any>(StudentContext);
  const userInfo = useContext<any>(UserInfoContext);
  const { screen, windowSize }: any = useWindowSize();
  const [followUp, setFollowUp] = useState<boolean>(false);
  const [addCommentArray, setaddCommentArray] = useState<
    AddCommentArrayInterface[]
  >([
    {
      name: "Subject",
      value: "subj",
      data: subjects,
      selectedValues: null,
      nextStep: "Type",
    },
    {
      name: "Type",
      value: "type",
      data: [
        {
          value: "ptm",
          label: "PTM",
        },
        {
          value: "followup",
          label: "LOP",
        },
        {
          value: "absentee",
          label: "Absentee",
        },
      ],
      selectedValues: null,
      nextStep: "Medium",
    },
    {
      name: "Medium",
      value: "ptmMode",
      data: PtmMode,
      selectedValues: null,
    },
  ]);

  // subjects update useEffect
  useEffect(() => {
    if (subjects && subjects.length) {
      const newArr = addCommentArray.map((step: any) => {
        if (step.name === "Subject") {
          return { ...step, data: subjects };
        } else return step;
      });
      setaddCommentArray(newArr);
    }
  }, [subjects]);

  // GET ALL COMMENTS
  const { makeRequest: postAddCommentData, loading: loadingSave } =
    usePutPostAPI(
      (data: any) => {
        ToastDispatch({
          isOpen: true,
          type: "Success",
          message: data.detailMessage,
        });
        pushToDataLayerForGTM({
          event: "ag_comment_add_comment",
          PSID: String(selectedStudent?.psid),
          EMPLOYEE_ID: userInfo?.employeeId,
          SUBJECT: filterState?.subj ?? "",
          COMMENT_TYPE: filterState?.type ?? "",
          FOLLOWUP_MODE: filterState?.ptmMode ?? "",
          FOLLOWUP_REASON: Array.isArray(filterState?.lopReason)
            ? filterState?.lopReason?.join(",")
            : filterState?.lopReason ?? "",
          FOLLOWUP_ACTION: filterState?.lopAction ?? "",
          EXPECTED_RETURN_DATE: filterState?.expectedReturnDate
            ? moment(filterState?.expectedReturnDate).format(
                "YYYY-MM-DD HH:mm:ss"
              )
            : "",
        });
        setFilterState({
          ...filterState,
          ptmMode: null,
        });
        setTimeout(() => {
          setRefreshComment(!refreshComment);
          setIsAddNewComment(false);
          clearFilters();
          scrollToHeader();
        }, 1000);
      },
      (error) => {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      },
      "POST"
    );
  // GET ALL COMMENTS
  const { makeRequest: postEditCommentData } = usePutPostAPI(
    (data: any) => {
      ToastDispatch({
        isOpen: true,
        type: "Success",
        message: data.detailMessage,
      });
      pushToDataLayerForGTM({
        event: "ag_comment_edit_comment",
        PSID: String(selectedStudent?.psid),
        EMPLOYEE_ID: userInfo?.employeeId,
        SUBJECT: filterState?.subj ?? "",
        COMMENT_TYPE: filterState?.type ?? "",
        FOLLOWUP_MODE: filterState?.ptmMode ?? "",
        FOLLOWUP_REASON: Array.isArray(filterState?.lopReason)
          ? filterState?.lopReason?.join(",")
          : filterState?.lopReason ?? "",
        FOLLOWUP_ACTION: filterState?.lopAction ?? "",
        EXPECTED_RETURN_DATE: filterState?.expectedReturnDate
          ? moment(filterState?.expectedReturnDate).format(
              "YYYY-MM-DD HH:mm:ss"
            )
          : "",
      });
      if (filterState?.type === "followup") {
        const lopFollowupCommentEvent = {
          event: "ag_lop_add_lop_followup_comment",
          PSID: String(selectedStudent?.psid),
          FOLLOWUP_REASON: Array.isArray(filterState?.lopReason)
            ? filterState?.lopReason?.join(",")
            : filterState?.lopReason ?? "",
          FOLLOWUP_ACTION: filterState?.lopAction ?? "",
          FOLLOWUP_MODE: filterState?.ptmMode ?? "",
        };
        pushToDataLayerForGTM(lopFollowupCommentEvent);
      }
      setFilterState({
        ...filterState,
        ptmMode: null,
      });
      setTimeout(() => {
        setRefreshComment(!refreshComment);
        setIsAddNewComment(false);
        clearFilters();
        setIsAddNewComment(false);
        scrollToHeader();
      }, 1000);
    },
    (error) => {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message: error.message,
      });
    },
    "PUT"
  );
  // Clear all filters
  const clearFilters = () => {
    setFilterState({
      subj: null,
      ptmMode: null,
      lopReason: null,
      lopAction: null,
      comment: "",
      expectedReturnDate: null,
    });
    setaddCommentArray(
      addCommentArray.map((step: any) => {
        return { ...step, selectedValues: null };
      })
    );
    setFollowUp(false);
  };

  // update filterState
  const handleAddFilterArrayList = (name: string, val: any) => {
    setFilterState((prevState: any) => ({
      ...prevState,
      [name]: val,
    }));
  };
  const toggletNewComment = () => {
    setIsAddNewComment(!isAddNewComment);
    setIsCommentEdit(false);
    clearFilters();
    scrollToHeader();
  };
  // open CommentBox directly
  useEffect(() => {
    if (isPaneOpenComment) {
      toggletNewComment();
    }
  }, [isPaneOpenComment]);
  // POST COMMENT HANDLER
  const sendCommenthandler = () => {
    const commentObj = { ...filterState };
    commentObj["branch"] = selectedStudent.branch;
    commentObj["stream"] = selectedStudent.stream;
    commentObj["clazz"] = selectedStudent.clazz;
    if (commentObj["lopAction"] == null) {
      delete commentObj["lopAction"];
    }
    if (commentObj["lopReason"] == null) {
      delete commentObj["lopReason"];
    }
    if (commentObj.type == "ptm") {
      delete commentObj["lopAction"];
      delete commentObj["lopReason"];
    }
    commentObj["psid"] = selectedStudent.psid;
    commentObj["facId"] = userInfo.facId;
    if (isCommentEdit) {
      // delete commentObj["type"];
      delete commentObj["updatedAt"];
      commentObj["commentId"] = commentObj["id"];
      delete commentObj["id"];
    } else {
      commentObj["lopReasons"] = commentObj["lopReason"];
      delete commentObj["lopReason"];
    }
    // post comment api
    isCommentEdit
      ? postEditCommentData(BASE_URL + POST_COMMENT, commentObj)
      : postAddCommentData(BASE_URL + POST_COMMENT, commentObj);
  };
  useEffect(() => {
    const footerElement = document.getElementById("footer");
    if (footerElement) {
      footerElement.scrollIntoView({ behavior: "smooth" });
    }
  }, [filterState]);
  const { subj, type } = filterState || {};
  const isUpdated = subj == "general" && type == "absentee";
  const showExpectedReturnDate = isUpdated;
  console.log("filterState", filterState, isUpdated);
  return (
    <div className="addCommentDivMain w-100">
      {isAddNewComment ? (
        <>
          <CommentStyledDiv height={windowSize.height}>
            <div className="addNewCommentDiv">
              <StyledLOPTitleDiv screen={screen}>
                {!isCommentEdit ? "Add New Comment" : "Edit Comment"}
              </StyledLOPTitleDiv>
              <span onClick={toggletNewComment} className="cursorPointer">
                <CloseIcon className="cursor-pointer"></CloseIcon>
              </span>
            </div>
            {subjects && subjects.length > 0 && !isCommentEdit ? (
              <div className="stepperDiv">
                <Stepper
                  addCommentArray={addCommentArray}
                  setaddCommentArray={setaddCommentArray}
                  setFollowUp={setFollowUp}
                  handleAddFilterArrayList={handleAddFilterArrayList}
                  filterState={filterState}
                  setFilterState={setFilterState}
                />
              </div>
            ) : null}
            {followUp && (
              <>
                <div className="lopMainDiv">
                  <StyledLOPTitleDiv screen={screen}>
                    Reason <span style={{ color: "red" }}>*</span>
                  </StyledLOPTitleDiv>
                  <div className="lopReasonListingDiv">
                    {lopReasonList && lopReasonList.length ? (
                      <>
                        <Select
                          size="large"
                          style={{ width: "100%" }}
                          options={lopReasonList.slice(4)}
                          placeholder={"Select Reason"}
                          value={filterState?.lopReason}
                          showSearch
                          optionFilterProp={"label"}
                          onChange={(value) => {
                            handleAddFilterArrayList("lopReason", [value]);
                          }}
                        />
                      </>
                    ) : null}
                  </div>
                </div>
                <div className="lopMainDiv">
                  <StyledLOPTitleDiv screen={screen}>
                    Action <span style={{ color: "red" }}>*</span>
                  </StyledLOPTitleDiv>
                  <div className="lopReasonListingDiv">
                    {lopActionList && lopActionList.length ? (
                      <>
                        <Select
                          size="large"
                          style={{ width: "100%" }}
                          options={lopActionList.slice(4)}
                          value={filterState?.lopAction}
                          placeholder={"Select Action"}
                          showSearch
                          optionFilterProp={"label"}
                          onChange={(value) => {
                            handleAddFilterArrayList("lopAction", value);
                          }}
                        />
                      </>
                    ) : null}
                  </div>
                </div>
                {showExpectedReturnDate && (
                  <div className="lopMainDiv">
                    <StyledLOPTitleDiv screen={screen}>
                      Expected Return Date{" "}
                      <span style={{ color: "red" }}>*</span>
                    </StyledLOPTitleDiv>
                    <div className="lopReasonListingDiv">
                      <DatePicker
                        size="large"
                        style={{ width: "100%" }}
                        value={
                          filterState.expectedReturnDate
                            ? moment(filterState.expectedReturnDate)
                            : undefined
                        }
                        onChange={(date) => {
                          handleAddFilterArrayList(
                            "expectedReturnDate",
                            date ? date.valueOf() : null
                          );
                        }}
                        disabledDate={(current) =>
                          current && current < moment().startOf("day")
                        }
                        placeholder="Select expected return date"
                      />
                    </div>
                  </div>
                )}
              </>
            )}
            <div id="footer"></div>
          </CommentStyledDiv>
          {filterState.ptmMode != null && filterState.type != "" && (
            <SendCommentBox
              viewAllComments={viewAllComments}
              loadingSave={loadingSave}
              filterState={filterState}
              setFilterState={setFilterState}
              sendCommenthandler={sendCommenthandler}
              isCommentEdit={isCommentEdit}
            />
          )}
        </>
      ) : (
        <div className="sendCommentBoxDiv2 p-0">
          {selectedStudent && (
            <Button
              color={"aeslPrimary footerAddCommentBtn"}
              className="d-flex justify-content-center w-100"
              onClick={toggletNewComment}
            >
              Add Comment
            </Button>
          )}
        </div>
      )}
    </div>
  );
};
export default StudentAddComment;

const Stepper: React.FC<any> = ({
  addCommentArray,
  setaddCommentArray,
  setFollowUp,
  handleAddFilterArrayList,
  setFilterState,
}: any) => {
  const [steps, setSteps] = useState<any[]>([]);
  const handleStepClick = (
    stepIndex: number,
    value: string,
    step: AddCommentArrayInterface
  ) => {
    if (value === "ptm") {
      setFollowUp(false);
    }
    if (step.name == "Medium") {
      const prevStep = addCommentArray[stepIndex - 1];
      if (
        prevStep.selectedValues == "followup" ||
        prevStep.selectedValues == "absentee"
      ) {
        setFollowUp(true);
      }
    }
    // update the filterState
    handleAddFilterArrayList(step.value, value);

    //handle validation for stepper
    handleValidation(step, value);

    //update steps of comment stepper
    handleUpdateSteps(stepIndex, value);
  };
  const handleUpdateSteps = (stepIndex: number, value: any) => {
    const updatedSteps = addCommentArray.map(
      (step: AddCommentArrayInterface, index: number) => {
        if (index === stepIndex) {
          setSteps((prev) => [...prev, step.nextStep]);
          return { ...step, selectedValues: value };
        } else if (index > stepIndex) {
          return { ...step, selectedValues: null };
        }
        return step;
      }
    );
    setaddCommentArray(updatedSteps);
  };
  const handleValidation = (step: AddCommentArrayInterface, value: any) => {
    if (step.name === "Subject") {
      setFilterState({
        subj: value,
        ptmMode: null,
        lopReason: [],
        lopAction: null,
        comment: "",
        type: "",
        expectedReturnDate: null,
      });
      setFollowUp(false);
    }
    if (step.name === "Type") {
      setFilterState((prevfilterState: any) => ({
        ...prevfilterState,
        ptmMode: null,
        lopReason: [],
        lopAction: null,
        comment: "",
        type: value,
        expectedReturnDate:
          value === "absentee" && prevfilterState.subj === "general"
            ? prevfilterState.expectedReturnDate
            : null,
      }));
    }
  };
  return (
    <div>
      {addCommentArray.map((step: AddCommentArrayInterface, index: number) => {
        return (
          <>
            {(steps.includes(step.name) || step.name == "Subject") && (
              <div key={index}>
                <StyledLOPTitleDiv screen={screen}>
                  Select {step.name}
                </StyledLOPTitleDiv>
                <div className="lopReasonListingDiv">
                  {step.data.map((option: any) => (
                    <StyledLOPListingDiv
                      isSelected={step.selectedValues === option.value}
                      key={option.value}
                      onClick={() => handleStepClick(index, option.value, step)}
                    >
                      {option.label}
                    </StyledLOPListingDiv>
                  ))}
                </div>
              </div>
            )}
          </>
        );
      })}
    </div>
  );
};
